(() => {
  'use strict';

  const initializeGallery = (gallery) => {
    if (gallery.dataset.adsReady) return;
    gallery.dataset.adsReady = 'true';
    const videos = [...gallery.querySelectorAll('[data-ad-video]')];

    videos.forEach((video) => {
      const errorMessage = video.closest('.ad-ads__card')?.querySelector('[data-ad-error]');
      video.addEventListener('play', () => {
        videos.forEach((other) => {
          if (other !== video && !other.paused) other.pause();
        });
      });
      const showError = () => {
        if (errorMessage) errorMessage.hidden = false;
      };
      video.addEventListener('error', showError);
      video.querySelector('source')?.addEventListener('error', showError);
      video.addEventListener('playing', () => {
        if (errorMessage) errorMessage.hidden = true;
      });
    });
  };

  const initializeWithin = (root) => {
    if (root.matches?.('[data-ads-gallery]')) initializeGallery(root);
    root.querySelectorAll('[data-ads-gallery]').forEach(initializeGallery);
  };

  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
